import WardrobeGrid from "./WardrobeGrid";

export default WardrobeGrid;
